// extracted by mini-css-extract-plugin
export default {"enableUserCredentialsUpdate":"update-organization-users-modal__enable-user-credentials-update__MOyW_","description":"update-organization-users-modal__description__WMck9"};